<template>
  <v-card :color="fondoEstado">
    <v-row no-gutters>
      <v-col md="8">
        {{ value.baso001.cod_nom }} -
        {{ value.baso001.des_nom }}
      </v-col>
      <v-col md="4">
        <v-select
          dense
          background-color="grey lighten-3"
          v-model.number="value.estado"
          :readonly="readonly"
          :items="estados"
          item-text="descripcion_estado"
          item-value="id_estado"
          :return-object="false"
          hide-selected
          hide-details
          style="max-width: 150px"
        >
        </v-select>
      </v-col>
    </v-row>
  </v-card>
</template>

<script>
export default {
  props: {
    value: Object,
    readonly: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      content: this.value,
      estados: [
        { id_estado: 1, descripcion_estado: "Pendiente" },
        { id_estado: 2, descripcion_estado: "Autorizado" },
        { id_estado: 3, descripcion_estado: "En Gestion" },
        { id_estado: 4, descripcion_estado: "Rechazado" },
      ],
    };
  },
  computed: {
    estado() {
      return this.value.estado;
    },
    fondoEstado() {
      let ret = "lime lighten-4";
      switch (this.value.estado) {
        case 1:
          ret = "red";
          break;
        case 2:
          ret = "green";
          break;
        case 3:
          ret = "orange lighten-1";
          break;
        case 4:
          ret = "grey";
          break;
        case 5:
          ret = "white";
          break;
        default:
          break;
      }
      return ret;
    },
  },

  watch: {
    estado() {
      this.$emit("input", this.content);
    },
  },
};
</script>

<style></style>
